export default "__VITE_ASSET__Bxgvm5Cx__"